// extracted by mini-css-extract-plugin
export default {"cls1":"kgwKEiqNSOMWVjGQLjyw","cls2":"FgoW6OrPIG4Q7aUgLKk8 kgwKEiqNSOMWVjGQLjyw","bookingAppRedesign":"m7_YDRFuh_8JsAwgsFpW"};